import { useForm } from "@mantine/form";
import { validateRequired } from "../../../utils/validations";
import { Button, NumberInput, TextInput } from "@mantine/core";
import { Contract } from "../../../types/types";
import { updateNotification } from "../../../utils/useNotification";
import CustomDatePicker from "../../common/Inputs/CustomDatePicker";
import { updateContractById } from "../../../api/contractApi";
import dayjs from "dayjs";

const ContractUpdateForm = ({
  contract,
  closeModal,
  updateContractList,
}: {
  contract: Contract;
  closeModal: any;
  updateContractList: any;
}) => {
  const form = useForm<any>({
    initialValues: {
      name: contract?.name,
      monthlyHours: contract?.monthlyHours,
      startDate: contract?.startDate
        ? dayjs(contract.startDate).toDate()
        : undefined,
      endDate: contract?.endDate ? dayjs(contract.endDate).toDate() : undefined,
    },
    validate: {
      name: validateRequired,
    },
  });

  const handleSubmit = async (values: object) => {
    try {
      const { data }: any = await updateContractById({
        id: contract?._id,
        updates: values,
      });
      if (data?.success) {
        updateNotification(data?.success);
        updateContractList();
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      closeModal();
    }
  };

  return (
    <form
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "15px",
      }}
      onSubmit={form.onSubmit(handleSubmit)}
    >
      <TextInput
        label="Kontrat İsmi"
        placeholder="Kontrat İsmi Giriniz."
        radius={10}
        maxLength={40}
        size="md"
        {...form.getInputProps("name")}
      />

      <NumberInput
        label="Aylık Çalışma Saati"
        placeholder="Örn: 10"
        hideControls
        size="md"
        {...form.getInputProps("monthlyHours")}
      />

      <CustomDatePicker
        label="Başlangıç Tarihi"
        placeholder="Tarih Seçiniz"
        w={"100%"}
        {...form.getInputProps("startDate")}
      />

      <CustomDatePicker
        label="Bitiş Tarihi"
        placeholder="Tarih Seçiniz"
        w={"100%"}
        {...form.getInputProps("endDate")}
      />

      <Button
        type="submit"
        color="#5C26FF"
        radius={10}
        disabled={!form.isDirty()}
      >
        Güncelle
      </Button>
    </form>
  );
};

export default ContractUpdateForm;
